import styled, { css } from 'styled-components';
import { BannerProps } from './Banner';

const BannerContainer = styled.span<BannerProps>(
	({
		theme: { spacings, gradients, fontWeights, fontSizes, colors },
		variant,
	}) => {
		return css`
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			width: 100%;
			backdrop-filter: blur(4px);
			z-index: 10;
			min-height: ${spacings[40]};
			border-radius: ${spacings[2]};
			color: ${colors.white[500]};
			background: ${gradients[variant]};
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			max-width: 100%;
			font-weight: ${fontWeights.medium};
			font-size: ${fontSizes.sm};
			white-space: nowrap;
		`;
	}
);

export { BannerContainer };
